module.exports = __webpack_public_path__ + "img/iconError.30b952b9.svg";